module.exports = require("react-pdf/dist/Page/TextLayer.css");